import request from '@/utils/request'

/**
 * 搜索详情列表
 * @param {*} params
 */
export function getExtraWorkList(params) {
  return request({
    url: '/overTime',
    method: 'get',
    params: params
  })
}
/**
 * 添加
 * @param {*} params
 */
export function addExtraWork(params) {
  return request({
    url: '/overTime',
    method: 'post',
    data: params
  })
}
/**
 * 修改
 */
export function editExtraWork(params) {
    return request({
      url: '/overTime',
      method: 'put',
      data: params
    })
  }
/**
 * 通过id删除
 */
export function deleteExtraWork(id) {
    return request({
      url: `/overTime/${id}`,
      method: 'delete',
    })
  }
  /**
   * 查看详情
   */
  export function getExtraWorkById(id) {
    return request({
      url: `/overTime/${id}`,
      method: 'get'
    })
  }